import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { SectionsGridDto, SectionsApi, SectionSearch } from "../../../../api";
import { Checkbox } from "@blueprintjs/core";

export interface ISectionListPageProps {}

export const SectionListPage: React.FunctionComponent<ISectionListPageProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(SectionsApi);
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: SectionsGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.section}/${row.sectionId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.section}/${row.sectionId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Code),
        fieldName: "code",
        render: (row: SectionsGridDto) => `${t(ETLCodes.Section)} ${row.code}`,
      },
      {
        header: () => t(ETLCodes.IsBeauty),
        headerAlignment: "center",
        fieldName: "isBeauty",
        alignment: "center",
        autoFitContent: true,
        render: (row: SectionsGridDto) => <Checkbox readOnly disabled checked={row.isBeauty} />,
      },
      {
        header: () => t(ETLCodes.IsWork),
        headerAlignment: "center",
        fieldName: "isWork",
        alignment: "center",
        autoFitContent: true,
        render: (row: SectionsGridDto) => <Checkbox readOnly disabled checked={row.isWork} />,
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.section}/0/detail/edit`);
  }, [history]);

  const search = React.useCallback(
    (sObj) => api.baseSearch(SectionSearch.fromJS({ ...sObj, languageCode: currentLanguage.languageCode })),
    [api, currentLanguage.languageCode]
  );

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(SectionSearch.fromJS({ ...sObj, languageCode: currentLanguage.languageCode }))
      }
      addFunc={addItemFunction}
      sortKeys={{ code: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Sections) }]}
    />
  );
};
